import "./BakeryToolbar.css";
import { MdAdd, MdSearch } from "react-icons/md";

function BakeryToolbar({
  search = "",
  onSearch = () => {},
  category = "All",
  onCategoryChange = () => {},
  onAdd = () => {},
}) {
  return (
    <div className="bakery-toolbar">

      <div className="bakery-toolbar-left">
        <h2>Bakery Management</h2>
        <p>Manage your bakery products</p>
      </div>

      <div className="bakery-toolbar-right">

        <div className="bakery-search-box">
          <MdSearch className="search-icon" />

          <input
            type="text"
            placeholder="Search products..."
            value={search}
            onChange={(e) => onSearch(e.target.value)}
          />
        </div>

        <select
          value={category}
          onChange={(e) => onCategoryChange(e.target.value)}
        >
          <option value="All">All Categories</option>
          <option value="Cakes">Cakes</option>
          <option value="Pastries">Pastries</option>
          <option value="Cookies">Cookies</option>
          <option value="Breads">Breads</option>
          <option value="Cupcakes">Cupcakes</option>
          <option value="Donuts">Donuts</option>
          <option value="Brownies">Brownies</option>
        </select>

        <button
          className="add-product-btn"
          onClick={onAdd}
        >
          <MdAdd />
          Add Product
        </button>

      </div>
    </div>
  );
}

export default BakeryToolbar;